module.exports = __webpack_public_path__ + "static/media/team--female-placeholder.ea44beac.jpg";